
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsCallPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.143 10.064a8.266 8.266 0 0 0 3.827 3.81c.248.117.54.095.767-.058l2.453-1.636c.22-.147.5-.173.744-.069l4.59 1.968c.32.136.512.467.47.813A4.705 4.705 0 0 1 14.328 19C6.967 19 1 13.033 1 5.672a4.705 4.705 0 0 1 4.108-4.666.781.781 0 0 1 .813.47l1.97 4.594a.784.784 0 0 1-.065.738l-1.63 2.491a.777.777 0 0 0-.053.765Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.14258 10.0641C6.9558 11.7266 8.30347 13.0682 9.96973 13.8738C10.2178 13.9914 10.5094 13.9693 10.7369 13.8158L13.1904 12.1798C13.4108 12.0328 13.6906 12.0071 13.9341 12.1115L18.5241 14.0786C18.8444 14.2146 19.0361 14.5461 18.9943 14.8916C18.6942 17.2402 16.6954 18.9999 14.3277 19C6.96703 19 1 13.033 1 5.67226C1.00012 3.30456 2.75977 1.30583 5.10837 1.00569C5.45387 0.963882 5.78537 1.1556 5.92143 1.47591L7.89026 6.06985C7.9937 6.31119 7.96944 6.58829 7.82565 6.808L6.19532 9.29908C6.04437 9.52704 6.02434 9.81756 6.14258 10.0641Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-call-phone.2ceaa84d3193c90bb348305fe08e5cdc.svg"),
        {
          React: SvgIconsCallPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      